<template>
	<div class="d-flex">
		<div v-show="!settings.showEntityTypeInPopover" :style="settings.style" :class="['nk-label-sa linked-label src-preview', settings.class]" v-html="displayText" @click="previewSource"></div>
		<nk-popover v-if="settings.popover.displayHtml" class="mr-2 " :options="componentOptions.popover"></nk-popover>

		<div ref="popContent" class="pop-body" style="display: none">
			<div class="no-gutters" v-show="settings.showEntityTypeInPopover">{{ $t('sale.factor.f.base') }} :
				<label style="cursor: pointer" class="text-secondary" @click="previewSource">{{ displayText }}</label>
			</div>
			<div class="pop-body" v-html="settings.popover.displayHtml"></div>
			<ul v-if="settings.popover.buttons?.length" class="toolbar">
				<li v-for="button of settings.popover.buttons">
					<a href="javascript:void(0)" @click="() => typeof button.handler === 'function' ? button.handler() : previewSource()"><i :class="button.icon"></i></a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import PreviewContainer from '~/components/form/preview-container'
	import { isFunction } from 'lodash'
	import _ from 'lodash'

	export default {
		name: 'SourcePreviewLabel',

		props: {
			modelValue: { default: '' },
			options: { type: Object }
		},
		created() {
			// this.settings = _.merge(this.settings, this.options)
			if (this.params?.options) _.merge(this.settings, this.params.options)
			if (this.params?.value) this.localModelValue = this.params.value
		},
		mounted() {
			this.componentOptions.popover.contentElement = $(this.$refs.popContent)
		},
		data() {
			return {
				localModelValue: null,
				componentOptions: {
					popover: {
						title: this.$t('form-info'),
						contentElement: '',
					}
				},
				settings: {
					class: '',
					entityId: '',
					entityType: '',
					format: null,
					style: {},
					popover: {
						displayHtml: ''
					},
				}
			}
		},

		computed: {
			displayText() {

				if (this.settings.format && isFunction(this.settings.format))
					return this.settings.format(this.localModelValue ? this.localModelValue : this.modelValue)

				else if (this.settings.format)
					return this.modelValue[this.settings.format]

				else
					return this.modelValue
			}
		},

		watch: {
			options: {
				deep: true,
				immediate: true,
				handler(val) {
					_.merge(this.settings, val)
					_.merge(this.componentOptions.popover, val?.popover)
				}
			}
		},

		methods: {
			previewSource() {
				if (this.settings && this.settings.entityId && this.settings.entityType) {
					var wait = this.$wait(this.grandParent)
					let changedOption = { entityType: this.settings.entityType, entityId: this.settings.entityId }
					if (this.settings.code) changedOption.code = this.settings.code
					if (this.settings.group) changedOption.group = this.settings.group
					this.showModal({
						component: PreviewContainer,
						data: null,
						options: changedOption,
					})
						.then((result) => { })
						.catch((err) => { })
						.finally(() => {
							wait.end()
						})
				}
			}
		},
	}
</script>

<style scoped>
	.linked-label:hover {
		text-decoration: underline;
	}

	.pop-body>div {
		padding: 3px;
		border-bottom: 1px dashed #ccc;
	}

	.pop-body>div:last-of-type {
		padding: 3px;
		border-bottom: none;
	}
</style>
